"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapKapiErrorResponseToSubmitReadError = exports.mapLegacyErrorResponseToSubmitReadError = void 0;
var utils_1 = require("../../utils");
var genericError = { errorCode: 'GENERIC' };
var isConsumptionErrorCode = function (reason) {
    return [
        'CONSUMPTION_TOO_HIGH',
        'LOWER_THAN_PREVIOUS_READING',
        'CONSUMPTION_OUTWITH_THRESHOLDS',
    ].includes(reason);
};
var mapErrorCode = function (reason) {
    return isConsumptionErrorCode(reason) ? reason : 'GENERIC';
};
var allReasonsExpected = function (reasons) {
    return reasons.every(function (_a) {
        var reason = _a.reason;
        return reason === 'CONSUMPTION_OUTWITH_THRESHOLDS';
    });
};
var allErrorCodesExpected = function (errors) {
    return errors.every(function (_a) {
        var errorCode = _a.errorCode;
        return isConsumptionErrorCode(errorCode);
    });
};
var isKapiErrorReason = function (error) {
    return typeof error.reason === 'string' &&
        typeof error.invalidAgainst !== 'undefined';
};
var isKapiError = function (error) {
    return typeof error.forceable !== 'undefined' &&
        Array.isArray(error.reason) &&
        error.reason.every(isKapiErrorReason);
};
var allGraphQLErrorsExpected = function (errors) {
    return errors.every(function (_a) {
        var path = _a.path, extensions = _a.extensions;
        return path &&
            (path.includes('submitElectricityMeterRead_nextV1') ||
                path.includes('submitGasMeterRead_nextV1')) &&
            isKapiError(extensions.error);
    });
};
var mapLegacyErrorToSubmitReadError = function (_a) {
    var passedCode = _a.errorCode, forceable = _a.forceable, invalidAgainst = _a.invalidAgainst;
    var errorCode = mapErrorCode(passedCode);
    if (errorCode === 'GENERIC') {
        return {
            errorCode: errorCode,
        };
    }
    return {
        errorCode: errorCode,
        forceable: forceable,
        invalidAgainst: invalidAgainst,
    };
};
var mapLegacyErrorResponseToSubmitReadError = function (_a) {
    var _b;
    var response = _a.response;
    if ((response === null || response === void 0 ? void 0 : response.status) === 400 && ((_b = response.data) === null || _b === void 0 ? void 0 : _b.errors)) {
        var mappedErrors = response.data.errors.map(mapLegacyErrorToSubmitReadError);
        if (mappedErrors.length && allErrorCodesExpected(mappedErrors)) {
            // The UI only handles one error and they are all the same severity so
            /// just return the first one.
            return mappedErrors[0];
        }
    }
    return genericError;
};
exports.mapLegacyErrorResponseToSubmitReadError = mapLegacyErrorResponseToSubmitReadError;
var mapKapiErrorToSubmitReadError = function (_a) {
    var forceable = _a.forceable, reason = _a.reason;
    if (reason.length && allReasonsExpected(reason)) {
        var reasonData = reason[0];
        if (reasonData) {
            var errorCode = mapErrorCode(reasonData.reason);
            if (errorCode !== 'GENERIC') {
                return {
                    errorCode: errorCode,
                    forceable: forceable,
                    invalidAgainst: reasonData.invalidAgainst
                        ? (0, utils_1.mapKapiMeterReadToLegacy)(reasonData.invalidAgainst)
                        : null,
                };
            }
        }
    }
    return genericError;
};
var mapKapiErrorResponseToSubmitReadError = function (error) {
    if (error.graphQLErrors.length &&
        // GraphQLErrors are not typed so we check they match our expectations.
        allGraphQLErrorsExpected(error.graphQLErrors)) {
        var mappedErrors = error.graphQLErrors
            .map(function (_a) {
            var extensions = _a.extensions;
            return extensions.error;
        })
            .map(function (error) {
            return isKapiError(error) ? mapKapiErrorToSubmitReadError(error) : undefined;
        })
            .filter(function (item) { return Boolean(item); });
        if (mappedErrors.length && allErrorCodesExpected(mappedErrors)) {
            // The UI only handles one error and they are all the same severity so
            // just return the first one.
            return mappedErrors[0];
        }
    }
    return genericError;
};
exports.mapKapiErrorResponseToSubmitReadError = mapKapiErrorResponseToSubmitReadError;
